export default __webpack_public_path__ + "static/media/search_resumes.44187c82.png";